import { render } from "./LiveTchatsView.vue?vue&type=template&id=1ae1580e&scoped=true&ts=true"
import script from "./LiveTchatsView.vue?vue&type=script&lang=ts"
export * from "./LiveTchatsView.vue?vue&type=script&lang=ts"

import "./LiveTchatsView.vue?vue&type=style&index=0&id=1ae1580e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae1580e"]])

export default __exports__